import React from 'react';
import { Chip, Drawer, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import moment from 'moment';
import { SimpleTable } from 'components';
import { invoiceColumns } from 'utils/constants/tableColumn/column';

interface Props {
    open: boolean;
    onClose: () => void;
    tableData?: any;
}

const Invoice: React.FC<Props> = ({ onClose, open, tableData }) => {
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            transitionDuration={600}
            PaperProps={{ elevation: 9 }}
            SlideProps={{ unmountOnExit: true }}
        >
            <SimpleTable
                columns={invoiceColumns}
                tableData={tableData}
            />
        </Drawer>
    );
};

export default Invoice;
